import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

/**
 * Confirmation dialog for deleting archives or unavailable dates
 */
const ConfirmationDialog = ({ open, title, message, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "#444349",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {title || "Confirmation de suppression"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: "#676767" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <WarningIcon color="warning" sx={{ fontSize: 32 }} />
        <Typography variant="body1" sx={{ color: "#676767" }}>
          {message ||
            "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible."}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: "#676767",
            borderColor: "#676767",
            "&:hover": {
              borderColor: "#444349",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            borderRadius: "8px",
            textTransform: "none",
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            borderRadius: "8px",
            textTransform: "none",
          }}
        >
          Confirmer la suppression
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
